import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { socket } from "../../api/socket.io";
import { useSelector } from "react-redux";
import { GoDash } from "react-icons/go";
import Confetti from "react-confetti";
import {
  FaBaseballBall,
  FaBowlingBall,
  FaUsers,
  FaTimesCircle,
} from "react-icons/fa";
import ballAudio from "../../certificates/cricketbatSound.mp3";
import sixAudio from "../../certificates/Six_Score.mp3";
// import winAudio from "../../certificates/matchWin.wav";
import endMatch from "../../certificates/endMatch.mp3";
import playBoll from "../../certificates/playBoll.wav";
import { MdOutlineDoNotDisturb } from "react-icons/md";
import { IoMdContact } from "react-icons/io";
import { useLocation } from "react-router-dom";
import backgroundAudio from "../../certificates/backupSong.mp3";
// import inningAudio from "../../certificates/inningaudio.mp3";

const ViewCricketMatch = () => {
  let { id } = useParams();
  const [match, setMatch] = useState(null);
  const [loading, setLoading] = useState(true);
  const [batsmanInput, setBatsmanInput] = useState("");
  const [bowlerInput, setBowlerInput] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const store = useSelector((store) => store.login.user.Role);
  const [bowlerAction, setBowlerAction] = useState(null);
  const [batsmanAction, setBatsmanAction] = useState(null);
  const [disbatsmanInput, setDisbatsmanInput] = useState("");
  const [disbowlerInput, setDisbowlerInput] = useState("");
  const [winAudioPlayed, setWinAudioPlayed] = useState(false);
  const user = useSelector((store) => store.login.user);
  const [showConfetti, setShowConfetti] = useState(false);

  const audioRef = useRef(null);
  const specialAudioRef = useRef(null);
  const location = useLocation(); // Get the current page URL

  useEffect(() => {
    const matchCompletedBefore = localStorage.getItem("matchCompleted");

    if (match?.Matchstatus === "Completed" && !matchCompletedBefore) {
      setShowConfetti(true);
      localStorage.setItem("matchCompleted", "true");

      setTimeout(() => {
        setShowConfetti(false);
      }, 13000);
    }
  }, [match?.Matchstatus]);

  //-------------------------------------------------------------Background Music------------------------------------------------

  useEffect(() => {
    if (store === process.env.REACT_APP_ROLE_ADMIN_S) {
      if (!audioRef.current) {
        audioRef.current = new Audio(backgroundAudio);
        audioRef.current.loop = true;
      }

      if (location.pathname === `/view-match/${id}`) {
        if (match?.Matchstatus !== "Completed") {
          setTimeout(() => {
            audioRef.current
              .play()
              .catch(() => console.log("Auto-play blocked"));
          }, 15000);
        }
      } else {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }

      return () => {
        if (location.pathname !== "/view") {
          audioRef.current.pause();
          audioRef.current.currentTime = 0;
        }
      };
    }
  }, [match?.Matchstatus, location.pathname]);

  // useEffect(() => {
  //   const audio = new Audio(backgroundAudio);
  //   audio.play();
  // }, [match?.Matchstatus=== "Completed"]);

  useEffect(() => {
    const handleUserInteraction = () => {
      if (match?.Matchstatus === "Completed" && !winAudioPlayed) {
        const audio = new Audio(endMatch);
        audio
          .play()
          .then(() => setWinAudioPlayed(true))
          .catch((error) => console.log("Playback error:", error));
      }
      document.removeEventListener("click", handleUserInteraction);
    };

    if (match?.Matchstatus === "Completed" && !winAudioPlayed) {
      document.addEventListener("click", handleUserInteraction);
    }

    return () => {
      document.removeEventListener("click", handleUserInteraction);
    };
  }, [match?.Matchstatus, winAudioPlayed]);

  useEffect(() => {
    socket.on("bowlEvent", (data) => {
      setBowlerAction(data);
      setTimeout(() => setBowlerAction(null), 3000);
    });

    socket.on("hitEvent", (data) => {
      setBatsmanAction(data);
      setTimeout(() => setBatsmanAction(null), 3000);
    });

    return () => {
      socket.off("bowlEvent");
      socket.off("hitEvent");
    };
  }, [socket]);

  function getRandomString(arr) {
    if (arr.length === 0) return null; // Handle empty array case
    const randomIndex = Math.floor(Math.random() * arr.length);
    return arr[randomIndex];
  }

  const playSpecialSound = (soundUrl) => {
    if (!soundUrl) return;

    if (audioRef.current) {
      audioRef.current.pause();
    }

    if (specialAudioRef.current) {
      specialAudioRef.current.pause();
      specialAudioRef.current.currentTime = 0;
    }

    specialAudioRef.current = new Audio(soundUrl);
    specialAudioRef.current
      .play()
      .catch(() => console.log("Error playing special sound"));

    specialAudioRef.current.onended = () => {
      if (audioRef.current) {
        audioRef.current.play().catch(() => console.log("Auto-play blocked"));
      }
    };
  };

  //---------------------------------------------------------------Inning Change Logic-------------------------------------------------

  useEffect(() => {
    socket.on("inningChange", (data) => {
      // console.log(`Massage: ${data.message}`);
      playSpecialSound(data.soundUrl);
    });

    return () => {
      socket.off("inningChange");
    };
  }, [socket]);

  // ------------------------------------------------------------ Four, Six, Out Sound --------------------------------------------------

  useEffect(() => {
    socket.on("scoreUpdate", (data) => {
      let soundUrl = null;
      // if (data.currentInning == "2") {
      //   console.log(`the current inning  is: ${data.currentInning}`);
      //   Toast("success", "Team B is batting now");
      //   soundUrl = playSpecialSound(
      //     "https://res.cloudinary.com/dph1m5tq7/video/upload/v1742291990/Cricket%20Match%20Sounds/tpk3gkyfjxcmpxjp9ecj.mp3"
      //   );
      // }

      if (store === process.env.REACT_APP_ROLE_ADMIN_S) {
        if (data.bowlerInput === data.batsmanInput) {
          const strings = [
            "https://res.cloudinary.com/bsgfcooa/video/upload/v1752557057/y4ly21jlgk15qvgbpnxb_wwvkxp_arahd8.mp3",
            "https://res.cloudinary.com/bsgfcooa/video/upload/v1752557082/zqazm4dggafmql0jiyti_uq8bo0_uhovlf.mp3",
          ];
          soundUrl = getRandomString(strings);
        } else if (data.batsmanInput === 4) {
          const strings = [
            "https://res.cloudinary.com/bsgfcooa/video/upload/v1752557117/ezjunjohfd8gghhve67u_zojroc_nppfri.mp3",
            "https://res.cloudinary.com/bsgfcooa/video/upload/v1752557142/z9q3iqkbyukes5y6h6wl_ilhvoz_fvlkyd.mp3",
          ];
          soundUrl = getRandomString(strings);
        } else if (data.batsmanInput === 6) {
          const strings = [
            "https://res.cloudinary.com/bsgfcooa/video/upload/v1752557170/d6rvwnnewnhmrvvu1qfi_wdakvr_d4esxx.mp3",
            "https://res.cloudinary.com/bsgfcooa/video/upload/v1752557197/gziqn4tfucxcouw81sz1_esdr1s_a1d1zg.mp3",
            "https://res.cloudinary.com/bsgfcooa/video/upload/v1752557220/sqw5fgodhyjo5cz7gv6v_law2wz_xojl7f.mp3",
            "https://res.cloudinary.com/bsgfcooa/video/upload/v1752557250/uqiozqqlr4ioceokkrkb_ic6ngd_jshccl.mp3",
            "https://res.cloudinary.com/bsgfcooa/video/upload/v1752557275/zalcqpg2e31mockpjbt3_u5ch7o_g742cv.mp3",
          ];
          soundUrl = getRandomString(strings);
        }

        if (soundUrl) {
          playSpecialSound(soundUrl);
        }
      }
    });

    return () => {
      socket.off("scoreUpdate");
    };
  }, [socket]);

  // useEffect(() => {
  //   socket.on("scoreUpdate", (data) => {
  //     if (store === process.env.REACT_APP_ROLE_ADMIN_S) {
  //       if (data.bowlerInput == data.batsmanInput) {
  //         const strings = [
  //           "https://res.cloudinary.com/dph1m5tq7/video/upload/v1741343103/Cricket%20Match%20Sounds/y4ly21jlgk15qvgbpnxb.mp3",
  //           "https://res.cloudinary.com/dph1m5tq7/video/upload/v1741343096/Cricket%20Match%20Sounds/zqazm4dggafmql0jiyti.mp3",
  //         ];
  //         const audio = new Audio(getRandomString(strings));
  //         audio.play();
  //         setTimeout(() => {
  //           audio.pause();
  //           audio.currentTime = 0;
  //         }, 15000);
  //       } else if (data.bowlerInput && data.batsmanInput == 4) {
  //         const strings = [
  //           "https://res.cloudinary.com/dph1m5tq7/video/upload/v1741343345/Cricket%20Match%20Sounds/ezjunjohfd8gghhve67u.mp3",
  //           "https://res.cloudinary.com/dph1m5tq7/video/upload/v1741344457/Cricket%20Match%20Sounds/z9q3iqkbyukes5y6h6wl.mp3",
  //         ];
  //         const audio = new Audio(getRandomString(strings));
  //         audio.play();
  //         setTimeout(() => {
  //           audio.pause();
  //           audio.currentTime = 0;
  //         }, 15000);
  //       } else if (data.bowlerInput && data.batsmanInput == 6) {
  //         const strings = [
  //           "https://res.cloudinary.com/dph1m5tq7/video/upload/v1741342013/Cricket%20Match%20Sounds/d6rvwnnewnhmrvvu1qfi.mp3",
  //           "https://res.cloudinary.com/dph1m5tq7/video/upload/v1741342012/Cricket%20Match%20Sounds/gziqn4tfucxcouw81sz1.mp3",
  //           "https://res.cloudinary.com/dph1m5tq7/video/upload/v1741342012/Cricket%20Match%20Sounds/sqw5fgodhyjo5cz7gv6v.mp3",
  //           "https://res.cloudinary.com/dph1m5tq7/video/upload/v1741344494/Cricket%20Match%20Sounds/uqiozqqlr4ioceokkrkb.mp3",
  //           "https://res.cloudinary.com/dph1m5tq7/video/upload/v1741344536/Cricket%20Match%20Sounds/zalcqpg2e31mockpjbt3.mp3",
  //         ];

  //         const audio = new Audio(getRandomString(strings));
  //         audio.play();
  //         setTimeout(() => {
  //           audio.pause();
  //           audio.currentTime = 0;
  //         }, 15000);
  //       }
  //     }
  //   });
  // }, []);

  useEffect(() => {
    setTimeout(() => setDisbatsmanInput(""), 3000);
  }, [disbatsmanInput]);

  useEffect(() => {
    setTimeout(() => setDisbowlerInput(""), 3000);
  }, [disbowlerInput]);

  useEffect(() => {
    socket.on("ReciveBastmanInput", (DisbastmaInput) => {
      // setBowlerInput(bowlerInput);
      setDisbatsmanInput(DisbastmaInput);
    });

    return () => {
      socket.off("ReciveBastmanInput");
    };
  }, [socket]);

  useEffect(() => {
    socket.on("ReciveBowlerInput", (DisbowlerInput) => {
      // setBowlerInput(bowlerInput);
      setDisbowlerInput(DisbowlerInput);
    });

    return () => {
      socket.off("ReciveBowlerInput");
    };
  }, [socket]);

  const handleBowl = (name) => {
    if (bowlerInput) {
      socket.emit("bowl", { player: `${name} bolwed the boll`, action: "🏀" });
    }
  };

  const handleHit = (name) => {
    socket.emit("hit", { player: `${name} hits the boll`, action: "🏏" });
  };

  useEffect(() => {
    socket.on("bollerInput", (bowlerInput) => {
      setBowlerInput(bowlerInput);
    });

    return () => {
      socket.off("bollerInput");
    };
  }, [socket]);

  useEffect(() => {
    fetchMatchDetails();

    socket.on("matchUpdated", (updatedMatch) => {
      if (updatedMatch.id === parseInt(id)) {
        setMatch(updatedMatch);
      }
    });

    return () => {
      socket.off("matchUpdated");
    };
  }, [id, socket]);

  const fetchMatchDetails = async () => {
    setLoading(true);
    try {
      const res = await performRequest("GET", `/match/view/${id}`);
      if (res.status === 200) {
        setMatch(res.data);
      } else {
        Toast("error", "Error fetching match details!");
      }
    } catch (err) {
      CustomErrorResponse(err);
    }
    setLoading(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    // socket.emit("reciveBIP", bowlerInput);

    if (!batsmanInput && !bowlerInput) {
      Toast("error", "Enter at least one input!");
      return;
    }

    if (batsmanInput && isNaN(batsmanInput)) {
      Toast("error", "Please enter a valid number for batsman!");
      return;
    }

    if (bowlerInput && isNaN(bowlerInput)) {
      Toast("error", "Please enter a valid number for bowler!");
      return;
    }

    if (bowlerInput && !batsmanInput) {
      if (/^[1-6]?$/.test(bowlerInput)) {
        // console.log("correct input");
      } else {
        Toast("error", "incorrect bowler input");
        return;
      }
    }

    if (batsmanInput) {
      if (/^[1-6]?$/.test(batsmanInput)) {
        // Toast("success", "correct  batsman input");
      } else {
        Toast("error", "incorrect batsman input ");
        return;
      }
    }

    if (batsmanInput && !bowlerInput) {
      Toast("error", "Please wait till bowler bowl boll !");
      return;
    }

    if (bowlerInput && !batsmanInput) {
      socket.emit("reciveBIP", bowlerInput);
      setBowlerInput("");
      return;
    }

    setIsSubmitting(true);

    const updatedBattingTeam = [...battingTeam];
    const currentBatsman = updatedBattingTeam[match.currentBatsmanIndex];

    // If batsman enters a valid input (not out, assuming 0 is out)
    if (batsmanInput) {
      currentBatsman.runs += parseInt(batsmanInput);
      currentBatsman.ballsFaced += 1;

      // If runs == 0, we mark the batsman as out
      if (parseInt(batsmanInput) === 0) {
        currentBatsman.playorNot = "out";
      }
    }

    // If the batsman is out, move to the next batsman
    if (currentBatsman.playorNot === "out") {
      const nextBatsmanIndex = match.currentBatsmanIndex + 1;
      if (nextBatsmanIndex < battingTeam.length) {
        match.currentBatsmanIndex = nextBatsmanIndex; // Move to the next batsman
      }
    }

    const requestData = {
      matchId: id,
      batsmanInput: batsmanInput ? parseInt(batsmanInput) : null,
      bowlerInput: bowlerInput ? parseInt(bowlerInput) : null,
      updatedBattingTeam,
    };

    try {
      const res = await performRequest("POST", `/match/update/`, requestData);

      if (res.status === 200) {
        setMatch(res.data.match);
        socket.emit("updateMatch", res.data.match);
        socket.emit("DisBastmanInput", res?.data?.batsmanInput);
        socket.emit("DisBowlerInput", res.data.bowlerInput);
        fetchMatchDetails();
        setBatsmanInput("");
        setBowlerInput("");
        // Toast("success", "Batsman hits the boll!");
      } else {
        Toast("error", "Error updating match!");
      }
    } catch (err) {
      CustomErrorResponse(err);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (loading) {
    return <p className="text-center mt-2 h4">Loading match details...</p>;
  }

  if (!match) {
    return <p className="text-center h4">Match not found!</p>;
  }

  const teamA = match.teamA;
  const teamB = match.teamB;
  const isTeamABatting = match.currentInning === 1;
  const battingTeam = isTeamABatting ? teamA : teamB;
  const bowlingTeam = isTeamABatting ? teamB : teamA;
  const currentBatsman = battingTeam[match.currentBatsmanIndex];
  const currentBowler = bowlingTeam[match.currentBowlerIndex];

  const showToast = () => {
    if (bowlerInput) {
      setTimeout(() => {
        document.getElementById("autoSubmitButton")?.click();
      }, 0);
    } else if (batsmanInput) {
      setTimeout(() => {
        document.getElementById("autoSubmitButton")?.click();
      }, 0);
    }
  };

  if (match.Matchstatus === "Completed") {
    const audio = new Audio(endMatch);
    audio.play();
  }

  return (
    <div className="">
      <style>
        {`
          .gradient-border {
              --borderWidth: 3px;
              background: #1D1F20;
              position: relative;
              border-radius: var(--borderWidth);
              }
          .gradient-border:after {
              content: '';
              position: absolute;
              top: calc(-1 * var(--borderWidth));
              left: calc(-1 * var(--borderWidth));
              height: calc(100% + var(--borderWidth) * 2);
              width: calc(100% + var(--borderWidth) * 2);
              background: linear-gradient(60deg, #f79533, #f37055, #ef4e7b, #a166ab, #5073b8, #1098ad, #07b39b, #6fba82);
              border-radius: calc(2 * var(--borderWidth));
              z-index: -1;
              animation: animatedgradient 3s ease alternate infinite;
              background-size: 300% 300%;
                }


              @keyframes animatedgradient {
	          0% {
		            background-position: 0% 50%;
	              }
	          50% {
		            background-position: 100% 50%;
	              }
	          100% {
		            background-position: 0% 50%;
	                }
              }

        `}
      </style>
      <div className="p-2 m-3">
        {showConfetti && (
          <Confetti width={window.innerWidth} height={window.innerHeight} />
        )}
        <div className="row gradient-border">
          <div
            className="col-12 col-md-3 border border-1 border-light"
            id="gradientBackground"
            style={{
              // border: "1px solid white",
              color: "white",
              //   background:
              //     "linear-gradient(-45deg,rgb(156, 223, 254),rgba(255, 253, 240, 0.5))",
              // }}
              backgroundImage:
                "linear-gradient(to right, #434343 0%, black 100%)",
            }}
          >
            <h1
              className="text-center p-2 m-2"
              style={{
                fontSize: "clamp(1.8em, 2.5vw, 2.5em)", // Responsive font size
                fontWeight: "900",
              }}
            >
              🏏 BATTING TEAM
            </h1>

            <hr className="m-0 p-0" style={{ border: "4px solid white" }} />

            <div
              className="col-12"
              style={{ fontSize: "clamp(1.5em, 2vw, 2em)" }}
            >
              <div>
                <div className="col-12 mt-1 p-2 ">
                  {battingTeam.map((player, index) => (
                    <div
                      key={index}
                      className="row py-2 no-gradient border border-1 border-light "
                      style={{
                        backgroundColor:
                          player?.playorNot === "out"
                            ? "rgba(224, 109, 109, 0.3)"
                            : "rgba(0, 255, 0, 0.1)",
                        // borderBottom: "1px solid black",
                        display: "flex",
                        flexWrap: "wrap", // Ensure wrapping on smaller screens
                      }}
                    >
                      <div className="col-8 text-truncate">
                        {index + 1}.&nbsp;{player?.name}
                      </div>
                      <div className="col-4 text-end">
                        {player?.runs || "0"} ({player.ballsFaced || "0"})
                        {player?.playorNot === "out" ? "🏀" : ""}
                        {index === match.currentBatsmanIndex && <>🏏</>}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Team dashboard Table code start-------------------------------------------------------------------------------- */}

          <div
            className="col-12 col-md-6 p-0 m-0 border border-1 border-light"
            style={{
              backgroundImage:
                "linear-gradient(to right, #434343 0%, black 100%)",
            }}
          >
            <h1
              className="text-center p-4 m-0"
              style={{
                backgroundImage:
                  "linear-gradient(to right, #434343 0%, black 100%)",
                color: "white",
                fontSize: "clamp(1.8em, 2.5vw, 2.5em)", // Responsive font size
                fontWeight: "600",
                textTransform: "uppercase",
              }}
            >
              {match.Matchstatus === "Completed"
                ? `${match.result} 🎉`
                : isTeamABatting
                ? "🏏 TEAM A BATTING"
                : "🏏 TEAM B BATTING"}
            </h1>

            <div className="row p-0 m-0">
              {/* Runs/Wickets */}
              <div
                className="col-6 text-center p-2 border border-1  border-dark"
                style={{ backgroundColor: "white" }}
              >
                <p
                  className="p-0 m-0"
                  style={{ fontSize: "1.5em", fontWeight: "600" }}
                >
                  RUNS/WICKETS
                </p>
                <h1
                  style={{
                    fontSize: "clamp(3em, 4vw, 4em)",
                    fontWeight: "900",
                  }}
                >
                  {isTeamABatting ? match.teamAScore : match.teamBScore} /{" "}
                  {
                    battingTeam.filter((player) => player.playorNot === "out")
                      .length
                  }
                </h1>
              </div>

              {/* Overs */}
              <div
                className="col-6 text-center p-2 border border-1  border-dark"
                style={{ backgroundColor: "white" }}
              >
                <p
                  className="p-0 m-0"
                  style={{ fontSize: "1.5em", fontWeight: "600" }}
                >
                  OVERS
                </p>
                <h1
                  style={{
                    fontSize: "clamp(3em, 4vw, 4em)",
                    fontWeight: "900",
                  }}
                >
                  {Math.floor(match.ballsBowled / 6)}.{match.ballsBowled % 6} /{" "}
                  {match.overs}
                </h1>
              </div>
            </div>

            {/* Team Scores */}
            <div
              className="text-center p-3"
              style={{
                backgroundImage:
                  "linear-gradient(to right, #434343 0%, black 100%)",
                color: "white",
                fontSize: "clamp(1.8em, 2.5vw, 2.5em)",
                fontWeight: "600",
              }}
            >
              <span>
                TEAM-A: <span className="fw-bold">{match.teamAScore}</span>
              </span>
              &nbsp;/&nbsp;
              <span>
                TEAM-B: <span className="fw-bold">{match.teamBScore}</span>
              </span>
            </div>

            <div className="row p-0 m-0">
              {/* Batsman Play */}
              <div
                className="col-6 text-center p-2 border border-1  border-dark"
                style={{ backgroundColor: "white" }}
              >
                <h1 className="mb-4 p-0">BATSMAN PLAY</h1>
                <h1
                  style={{
                    fontSize: "clamp(3em, 4vw, 4em)",
                    fontWeight: "900",
                  }}
                >
                  <span style={{ fontSize: "1.5em" }}>
                    {match?.currentBatsmanInput || <GoDash />}
                  </span>
                </h1>
              </div>

              {/* Bowler Play */}
              <div
                className="col-6 text-center p-2 border border-1  border-dark"
                style={{ backgroundColor: "white" }}
              >
                <h1 className="mb-4 p-0">BOWLER PLAY</h1>
                <h1
                  className="mt-2"
                  style={{
                    fontSize: "clamp(3em, 4vw, 4em)",
                    fontWeight: "900",
                  }}
                >
                  <span style={{ fontSize: "1.5em" }}>
                    {match?.currentBowlerInput || (
                      <FaBaseballBall
                        style={{ color: "#EC5800" }}
                      ></FaBaseballBall>
                    )}
                  </span>
                </h1>
              </div>
            </div>

            {/* Bowling & Batting Actions */}
            <div className="row p-0 m-0">
              {/* Bowling */}
              <div
                className="col-12 col-md-6 border text-center p-2"
                style={{
                  fontSize: "clamp(1.5em, 2vw, 2em)",
                  fontWeight: "900",
                  backgroundImage:
                    "linear-gradient(to right, #434343 0%, black 100%)",
                  color: "white",
                }}
              >
                <h1 className="border-bottom border-1 border-light pb-2">
                  BOWLING
                </h1>
                {bowlerAction?.action ? (
                  <div className="col-12 mt-2 text-center">
                    <div
                      style={{
                        fontSize: "clamp(2em, 2.5vw, 2.5em)",
                        fontWeight: "900",
                      }}
                    >
                      {bowlerAction.action}
                    </div>
                  </div>
                ) : (
                  <GoDash />
                )}
                <div
                  className="col-12 text-center"
                  style={{
                    fontSize: "clamp(0.8em, 1vw, 1em)",
                    fontWeight: "500",
                  }}
                >
                  {bowlerAction?.player}
                </div>
              </div>

              {/* Batting */}
              <div
                className="col-12 col-md-6 text-center border p-2"
                style={{
                  fontSize: "clamp(1.5em, 2vw, 2em)",
                  fontWeight: "900",
                  backgroundColor: "black",
                  color: "white",
                }}
              >
                <h1 className="border-bottom border-1 border-light pb-2">
                  BATTING
                </h1>
                {batsmanAction?.action ? (
                  <div className="col-12 mt-2 text-center">
                    <div
                      style={{
                        fontSize: "clamp(2em, 2.5vw, 2.5em)",
                        fontWeight: "900",
                      }}
                    >
                      {batsmanAction.action}
                    </div>
                  </div>
                ) : (
                  <GoDash />
                )}
                <div
                  className="col-12 text-center"
                  style={{
                    fontSize: "clamp(0.8em, 1vw, 1em)",
                    fontWeight: "500",
                  }}
                >
                  {batsmanAction?.player}
                </div>
              </div>
            </div>
          </div>

          {/* Bowling team Table code start-------------------------------------------------------------------------------- */}

          <div
            className="col-12 col-md-3 border border-1 border-light"
            id="gradientBackground"
            style={{
              // border: "1px solid light",
              color: "white",
              //   background:
              //     "linear-gradient(-45deg,rgb(156, 223, 254),rgba(255, 253, 240, 0.5))",
              // }}
              backgroundImage:
                "linear-gradient(to right, #434343 0%, black 100%)",
            }}
          >
            <h1
              className="text-center p-2 m-2"
              style={{
                fontSize: "clamp(1.8em, 2.5vw, 2.5em)", // Responsive font size
                fontWeight: "900",
              }}
            >
              🏀 BOWLING TEAM
            </h1>

            <hr className="m-0 p-0" style={{ border: "4px solid white" }} />

            <div className="col-12 p-2">
              <div className="row">
                <div
                  className="col-12 mt-1 "
                  style={{ fontSize: "clamp(1.5em, 2vw, 2em)" }}
                >
                  {bowlingTeam.map((player, index) => (
                    <div
                      key={index}
                      className="row py-2 border border-1 border-light"
                      style={{
                        backgroundColor: "rgba(0, 255, 0, 0.1)",
                        // borderBottom: "1px solid black",
                        display: "flex",
                        flexWrap: "wrap", // Ensures wrapping on smaller screens
                      }}
                    >
                      <div className="col-8 text-truncate">
                        {index + 1}.&nbsp;{player?.name}
                      </div>
                      <div className="col-4 text-end">
                        {player?.wicketsTaken || "0"}W
                        {`(${player?.ballsBowled || "0"})`}{" "}
                        {index === match.currentBowlerIndex && "🏀"}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* current code start-------------------------------------------------------------------------------- */}

        <div className="row mt-3">
          <div
            className="col-12 col-md-6 border border-1 border-light"
            style={{
              // backgroundImage:
              //   "linear-gradient(to right, #434343 0%, black 100%)",
              color: "white",
              backgroundImage:
                "linear-gradient(to right,rgb(96, 110, 133) 0%, #002244 100%)",
            }}
          >
            <h1
              className="text-center p-4 m-0 "
              // style={{ fontSize: "2.5em", fontWeight: "900" }}
              style={{
                fontSize: "clamp(1.7em, 2vw, 2.5em)",
                fontWeight: "900",
              }}
            >
              🏏 BATTING PLAYER
            </h1>

            <div className="row justify-content-center">
              {battingTeam.map((player, index) =>
                index === match.currentBatsmanIndex ? (
                  <div
                    key={index}
                    className="row border-top border-1 border-light p-3 w-100"
                  >
                    <div className="row ">
                      <div className="col-md-4 col-12  d-flex flex-column align-items-center justify-content-center">
                        <div className="text-center p-3">
                          {player?.image ? (
                            <img
                              src={player?.image}
                              alt="Player"
                              className="shadow me-lg-5"
                              style={{
                                height: "200px",
                                width: "200px",
                                // border: "1px solid black",
                              }}
                            />
                          ) : (
                            <IoMdContact
                              style={{
                                height: "200px",
                                width: "200px",
                                // border: "1px solid black",
                              }}
                            />
                          )}
                        </div>
                      </div>
                      <div
                        className="col-md-8 col-12 p-3"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {/* Team Name */}
                        <div className="col-12 text-md-start text-center">
                          <h1 className="fw-bold" style={{ fontSize: "2em" }}>
                            TEAM - {player?.team}
                          </h1>
                        </div>

                        {/* Player Name */}
                        <div className="col-12 text-md-start text-center">
                          <h1 className="fw-bold text-light text-2xl">
                            {player.name}
                          </h1>
                        </div>

                        {/* Player Stats */}
                        <div className="col-12 text-md-start text-center">
                          <h2 className="fw-bold text-1xl p-0">
                            🏏 {player?.runs || "0"} RUNS | 🏀&nbsp;
                            {player?.ballsFaced || "0"} BALLS |
                            {player?.playorNot === "out" ? (
                              <span className="text-danger fw-bold">
                                - <FaTimesCircle /> OUT
                              </span>
                            ) : (
                              <span>
                                &nbsp;
                                <MdOutlineDoNotDisturb
                                  style={{
                                    fontSize: "20px",
                                    marginTop: "-5px",
                                    color: "#90EE90",
                                  }}
                                />{" "}
                                NOT OUT
                              </span>
                            )}
                          </h2>
                        </div>

                        {/* Bowler Action Alert */}
                        {!player.isOut &&
                          index === match.currentBatsmanIndex &&
                          bowlerAction && (
                            <div className="col-12 mt-2">
                              <div
                                className="alert alert-success text-center d-none"
                                role="alert"
                              >
                                {bowlerAction.player} {bowlerAction.action}!
                              </div>
                            </div>
                          )}

                        {user.UserId !== player.id && (
                          <div style={{ height: "50px" }}></div>
                        )}

                        {/* Batting Input (Only for Current Batsman) */}
                        {!player.isOut &&
                          index === match.currentBatsmanIndex &&
                          user.UserId === player.id && (
                            <div className="col-12 d-flex flex-wrap  justify-content-md-start justify-content-center gap-2 py-2">
                              {[1, 2, 3, 4, 5, 6].map((run) => (
                                <button
                                  key={run}
                                  className="btn btn-lg btn-primary border border-1 border-light px-4"
                                  disabled={match.Matchstatus === "Completed"}
                                  onClick={() => {
                                    setBatsmanInput(run);
                                    handleHit(player.name);
                                    showToast();
                                    const audio = new Audio(ballAudio);
                                    audio.play();
                                  }}
                                >
                                  {run}
                                </button>
                              ))}
                            </div>
                          )}
                      </div>
                    </div>

                    {/* <div className="col-12 text-center">
                      <img
                        src={player?.image}
                        style={{
                          height: "200px",
                          width: "200px",
                          borderRadius: "50%",
                        }}
                      ></img>
                    </div> */}

                    {/* Player Name */}
                    {/* <div className="col-12 text-center">
                      <h1 className="fw-bold" style={{ fontSize: "2em" }}>
                        {player.name}
                      </h1>
                    </div> */}

                    {/* Player Stats */}
                    {/* <div className="col-12  text-center py-2">
                      <h2 className="fw-bold">
                        🏏 {player?.runs || "0"} RUNS | 🏀&nbsp;
                        {player?.ballsFaced || "0"} BALLS |
                        {player?.playorNot === "out" ? (
                          <span className="text-danger fw-bold">
                            - <FaTimesCircle /> OUT
                          </span>
                        ) : (
                          " NOT OUT"
                        )}
                      </h2>
                    </div> */}
                  </div>
                ) : null
              )}
            </div>
          </div>

          <div
            className="col-12 col-md-6 border border-1 border-light"
            style={{
              backgroundImage:
                "linear-gradient(to right,rgb(96, 110, 133) 0%, #002244 100%)",
              color: "white",
            }}
          >
            <h2
              className="text-center p-3 mt-1 "
              style={{
                fontSize: "clamp(1.7em, 2vw, 2.5em)",
                fontWeight: "900",
              }}
            >
              🏀 BOWLING PLAYER
              {/* {`${bowlerInput} , ${batsmanInput}`} */}
            </h2>

            <div className="row justify-content-center">
              {bowlingTeam.map((player, index) =>
                index === match.currentBowlerIndex ? (
                  <div
                    key={index}
                    className="row border-top border-1 border-light p-3 w-100"
                  >
                    <div className="row">
                      {/* Player Image Section */}
                      <div className="col-md-4 col-12 d-flex flex-column align-items-center justify-content-center">
                        <div className="text-center">
                          {player?.image ? (
                            <img
                              src={player?.image}
                              alt="Player"
                              className="shadow me-lg-5"
                              style={{
                                height: "200px",
                                width: "200px",
                                // border: "1px solid black",
                              }}
                            />
                          ) : (
                            <IoMdContact
                              style={{
                                height: "200px",
                                width: "200px",
                                // border: "1px solid black",
                              }}
                            />
                          )}
                        </div>
                      </div>

                      {/* Player Info Section */}
                      <div className="col-md-8 col-12 p-3">
                        {/* Team Name */}
                        <h1
                          className="fw-bold text-light text-center text-md-start"
                          style={{ fontSize: "2em" }}
                        >
                          TEAM - {player?.team}
                        </h1>

                        {/* Player Name */}
                        <h1 className="fw-bold text-light text-2xl  text-center text-md-start">
                          {player?.name}
                        </h1>

                        {/* Player Stats */}
                        <h2 className="fw-bold text-1xl  text-center text-md-start">
                          🎳 {player.wicketsTaken || "0"} WICKETS | 🏀{" "}
                          {player.ballsBowled || "0"} BALLS
                        </h2>

                        {/* Batsman Action Alert */}
                        {batsmanAction && (
                          <div className="alert alert-success text-center my-2 d-none">
                            {batsmanAction.player} {batsmanAction.action}!
                          </div>
                        )}

                        {user.UserId !== player.id && (
                          <div style={{ height: "50px" }}></div>
                        )}

                        {/* Bowling Input (Only for Current Bowler) */}
                        {user.UserId === player.id && (
                          <div className="d-flex flex-wrap justify-content-md-start justify-content-center gap-2 py-2 ">
                            {[1, 2, 3, 4, 5, 6].map((num) => (
                              <button
                                key={num}
                                className="btn btn-lg btn-primary px-4 border border-1 border-light "
                                disabled={match.Matchstatus === "Completed"}
                                onClick={() => {
                                  setBowlerInput(num);
                                  handleBowl(player.name);
                                  showToast();
                                  const audio = new Audio(playBoll); // Replace with your actual audio file path
                                  audio.play();
                                }}
                              >
                                {num}
                              </button>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ) : null
              )}
            </div>
          </div>
        </div>

        {/* original code start-------------------------------------------------------------------------------- */}

        <div className="text-center mt-4">
          <button
            className="btn btn-success"
            id="autoSubmitButton"
            style={{ display: "none" }}
            onClick={handleSubmit}
            disabled={
              !(batsmanInput || bowlerInput) ||
              isSubmitting ||
              match.Matchstatus === "Completed"
            }
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewCricketMatch;
